import NavbarComponent from './NavbarComponent'

export default NavbarComponent
